import React from 'react';
import ComboBox from '../../../../../components/ComboBox';
import SelectUserComboBox from '../../../../../components/SelectUserComboBox';
import FilterTags from '../../../../../components/FilterTags';
import DatePicker from '../../../../../components/DatePicker';
import DataSource from '../../../../../dao/DataSource/DataSource';

import './ProjectTimelineFilters.scss';

import BaseComponent from '../../../../../baseClasses/BaseComponent';

const ONE_MINUTE = 1000 * 60;
const ONE_HOUR = ONE_MINUTE * 60;
const ONE_DAY = ONE_HOUR * 24;

var abrMonthNames = [
  'Jan', 'Feb', 'Mar',
  'Apr', 'May', 'Jun', 'Jul',
  'Aug', 'Sep', 'Oct',
  'Nov', 'Dec',
];

function getLocalDateOnly(gmtDate) {
  let tempDate = new Date(new Date(gmtDate));
  if (gmtDate && gmtDate.length) {
    let offset = tempDate.getTimezoneOffset();
    tempDate = new Date(new Date(tempDate).getTime() + offset * 1000 * 60);
  }
  return tempDate;
}

function _formatDate(date) {
  
  var day = date.getDate();

  return abrMonthNames[date.getMonth()] + ' ' + day;
}

function formatDate(timeframe) {
  return (timeframe.startTime ? _formatDate(getLocalDateOnly(timeframe.startTime)) : 'All') + ' - ' + (timeframe.endTime ? _formatDate(getLocalDateOnly(timeframe.endTime)) : 'All');
}

export default class ProjectTimelineFilters extends BaseComponent {
  constructor(props){
    super(props);
    
    this.state = {
      vendorCompanies: props.selectedFilters && props.selectedFilters.vendorCompanies,
      projectMembers: props.selectedFilters && props.selectedFilters.projectMembers,
      timeframe: props.selectedFilters && props.selectedFilters.timeframe,
      eventTypes: props.selectedFilters && props.selectedFilters.eventTypes,
      project: props.project,
    };
    
  }

  handleInitialization() {
    const { project } = this.state;
    let selectableUsers = [];
    let vendorCompanies = project.users ? project.users.map(user => {
      user.name = user.first_name + ' ' + user.last_name;
      selectableUsers.push(user);
      if (user.companies && user.companies.length > 0 &&
        user.companies[0].id != this.props.currentCompany.id) {
        return user.companies[0];
      }
      else {
        return null;
      }
    }) : [];

    let filteredVendorCompanies = [this.props.currentCompany];
    for (let i = 0; i < vendorCompanies.length; i++){
      const vc = vendorCompanies[i];
      if (vc && !filteredVendorCompanies.find(tvc => {
        return tvc.id == vc.id;
      })){
        filteredVendorCompanies.push(vc);
      }
    }
    this.setState({ selectableUsers, selectableVendorCompanies: filteredVendorCompanies });
  }

  handleProjectRetrieval(project, action, acData, fetchedData) {
    if (acData) {
      this.setState({ project: fetchedData });
    }
    else {
      this.setState({ project }, () => {
        this.handleInitialization();
      });
    }
  }

  componentDidMount() {
    this.projectDataSource = new DataSource('Project', this.props.project.id, { project: { builds: {}, all_locations: {}, users: {  }, project_contacts: { user: {} } } }, this.handleProjectRetrieval);
    this.projectDataSource.get();
  }

  handleClickOutside(event) {
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedFilters != this.props.selectedFilters && this.props.selectedFilters) {
      const { vendorCompanies, projectMembers, timeframe, eventTypes, locations, builds } = this.props.selectedFilters;
      this.setState({
        vendorCompanies,
        projectMembers,
        timeframe,
        eventTypes,
        locations,
        builds,
      });
      this.handleInitialization();
    }
  }
  
  handleCloseMenu(){
    if (this.state.menu){
      this.setState({ menu: null, displayMenu: '' });
    }
  }

  handleProjectMemberFilterRemoved(filtersRemoved) {
    let { projectMembers } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.projectMembers = projectMembers.filter((projectMember) => {
      return !filtersRemoved.find((projectMemberRemoved) => {
        return projectMemberRemoved.id == projectMember.id;
      });
    });
    if (selectedFilters.projectMembers.length == 0) {
      selectedFilters.projectMembers = null;
    }
    handleFilterChange(selectedFilters);
  }

  handleVendorCompaniesFilterRemoved(filtersRemoved) {
    let { vendorCompanies } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.vendorCompanies = vendorCompanies.filter((vendorCompany) => {
      return !filtersRemoved.find((vendorCompanyRemoved) => {
        return vendorCompanyRemoved.type == vendorCompany.type;
      });
    });
    if (selectedFilters.vendorCompanies.length == 0) {
      selectedFilters.vendorCompanies = null;
    }
    handleFilterChange(selectedFilters);
  }

  handleTimeFrameFilterRemoved(dateFilters) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.timeframe = null;
    handleFilterChange(selectedFilters);
  }

  handleEventTypeFilterRemoved(filtersRemoved) {
    let { eventTypes } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.eventTypes = eventTypes.filter((eventType) => {
      return !filtersRemoved.find((eventTypeRemoved) => {
        return eventTypeRemoved.type == eventType.type;
      });
    });
    if (selectedFilters.eventTypes.length == 0) {
      selectedFilters.eventTypes = null;
    }
    handleFilterChange(selectedFilters);
  }

  handleLocationFilterRemoved(filtersRemoved) {
    let { locations } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.locations = locations.filter((location) => {
      return !filtersRemoved.find((locationRemoved) => {
        return locationRemoved.type == location.type;
      });
    });
    if (selectedFilters.locations.length == 0) {
      selectedFilters.locations = null;
    }
    handleFilterChange(selectedFilters);
  }

  handleBuildFilterRemoved(filtersRemoved) {
    let { builds } = this.state;
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.builds = builds.filter((build) => {
      return !filtersRemoved.find((buildRemoved) => {
        return buildRemoved.type == build.type;
      });
    });
    if (selectedFilters.builds.length == 0) {
      selectedFilters.builds = null;
    }
    handleFilterChange(selectedFilters);
  }

  handleProjectMemberSelection(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ projectMembers: multipleSelections });
    selectedFilters.projectMembers = multipleSelections.length ? multipleSelections : null;
    handleFilterChange(selectedFilters);
  }

  handleVendorCompanySelection(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ vendorCompanies: multipleSelections });
    selectedFilters.vendorCompanies = multipleSelections.length ? multipleSelections : null;
    handleFilterChange(selectedFilters);
  }

  handleStartDateSelection(date) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    if (!selectedFilters.timeframe) {
      selectedFilters.timeframe = {};      
    }
    selectedFilters.timeframe.startTime = getLocalDateOnly(date);
    if (!selectedFilters.timeframe.endTime) {
      selectedFilters.timeframe.endTime = null;
    }
    this.setState({ timeframe: selectedFilters.timeframe });
    handleFilterChange(selectedFilters);
  }
  
  handleEndDateSelection(date) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    if (!selectedFilters.timeframe) {
      selectedFilters.timeframe = {};      
    }
    if (!selectedFilters.timeframe.startTime) {
      selectedFilters.timeframe.startTime = null;
    }
    selectedFilters.timeframe.endTime = new Date(getLocalDateOnly(date).getTime() + (ONE_DAY - 1));
    this.setState({ timeframe: selectedFilters.timeframe });
    handleFilterChange(selectedFilters);
  }

  handleEventTypeSelection(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ eventTypes: multipleSelections });
    selectedFilters.eventTypes = multipleSelections.length ? multipleSelections : null;
    handleFilterChange(selectedFilters);
  }
  
  handleLocationSelection(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ locations: multipleSelections });
    selectedFilters.locations = multipleSelections.length ? multipleSelections : null;

    if (selectedFilters.builds) {
      let filtersRemoved = [];
      selectedFilters.builds = selectedFilters.builds.filter(build => {
        if (build.location_id && selectedFilters.locations) {
          if (!selectedFilters.locations.find(location => { return location.type == build.location_id; })) {
            filtersRemoved.push(build);
            return false;
          }
        }
        return true;
      });
      if (filtersRemoved) {
        this.handleBuildFilterRemoved(filtersRemoved);
      }
    }
    handleFilterChange(selectedFilters);
  }
  
  handleBuildSelection(multipleSelections) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ builds: multipleSelections });
    selectedFilters.builds = multipleSelections.length ? multipleSelections : null;
    if (selectedFilters.locations) {
      this.handleLocationFilterRemoved(selectedFilters.locations);
      selectedFilters.locations = null;
    }
    handleFilterChange(selectedFilters);
  }
  
  render() {
    let { projectMembers, vendorCompanies, timeframe, eventTypes, locations, builds } = this.state;
    const { startDate, endDate } = this.props;
    const { project, selectableVendorCompanies, selectableUsers } = this.state;
    if (!project) {
      return;
    }
    const vendorCompaniesMenu = selectableVendorCompanies && 
      selectableVendorCompanies.filter(vc => vc && vc.id && vc.name).map(vc => {
        let selected = !!vendorCompanies && vendorCompanies.find(vc2 => {
          return vc2.type == vc.id;
        });
        return { type: vc.id, name: vc.name, selected };
      });

    const eventTypesMenu = [{ type: 'delays', name: 'Delays' }, { type: 'completion', name: 'Work Completion' }, { type: 'quality', name: 'Work Quality' }].map(et => {
      let selected = !!eventTypes && eventTypes.find(et2 => {
        return et2.type == et.type;
      });
      return { type: et.type, name: et.name, selected };
    });

    const locationsMenu = (!builds || !builds.length) && project && project.all_locations ? project.all_locations.map(location => {
      const selected = !!locations && locations.find(location2 => {
        return location2.type == location.id;
      });
      return { type: location.id, name: location.name, selected };
    }): [];
    
    const filteredBuilds = project && project.builds ? project.builds.filter(build => {
      if (!build.ancestry) {
        return false;
      }
      if (locations && locations.length > 0) {
        return (!build.location_id && locations.find(loc => { return project.location_id == loc.type; })) ||
          (build.location_id && locations.find(loc => { return build.location_id == loc.type; }));
      }
      else {
        return true;
      }
    }): [];
    const buildsMenu = filteredBuilds.map(build => {
      const selected = !!builds && builds.find(build2 => {
        return build2.type == build.id;
      });
      return { type: build.id, name: build.name, location_id: build.location_id, selected };
    });
    
    let vendorCompanySelector = (
      <ComboBox
        id={'vendorCompaniesPicker'}
        options={vendorCompaniesMenu}
        multiSelect={true}
        hasBorder={false}
        underlined={false}
        height={32}
        width={256}
        displayFontStyle={{ fontSize: '12px' }}
        handleMultiMenuSelection={this.handleVendorCompanySelection}
        defaultText={'--All Companies--'}
      />
    );

    let eventTypeSelector = (
      <ComboBox
        id={'eventTypePicker'}
        options={eventTypesMenu}
        multiSelect={true}
        hasBorder={false}
        underlined={false}
        height={32}
        width={256}
        displayFontStyle={{ fontSize: '12px' }}
        handleMultiMenuSelection={this.handleEventTypeSelection}
        defaultText={'--All Events--'}
      />
    );

    let locationsSelector = null;
    if (project.all_locations && project.all_locations.length > 1 && (!builds || builds.length == 0)) {
      locationsSelector = (
        <ComboBox
          id={'locationPicker'}
          options={locationsMenu}
          multiSelect={true}
          hasBorder={false}
          underlined={false}
          height={32}
          width={256}
          displayFontStyle={{ fontSize: '12px' }}
          handleMultiMenuSelection={this.handleLocationSelection}
          defaultText={'--All Locations--'}
        />
      );
    }

    let buildsSelector = (
      <ComboBox
        id={'buildPicker'}
        options={buildsMenu}
        multiSelect={true}
        hasBorder={false}
        underlined={false}
        height={32}
        width={256}
        displayFontStyle={{ fontSize: '12px' }}
        handleMultiMenuSelection={this.handleBuildSelection}
        defaultText={'--All Builds--'}
      />
    );

    let projectMemberSelector =
      <SelectUserComboBox
        key="project_memberPicker"
        hasBorder={false}
        multiSelect={true}
        height={32}
        width={256}
        selectedUsers={projectMembers ? projectMembers : []}
        menuUp={false}
        menuBelow={true}
        handleMultipleSelection={this.handleProjectMemberSelection}
        displayFontStyle={{ fontSize: '12px' }}
        useMultiTab={false}
        users={selectableUsers}
        defaultText={'--All Project Members--'}
      />;

    let startDatePicker = (
      <div className="project-timeline-date-selector">
        <div className="date-picker-container">
          <DatePicker
            selected={timeframe ? timeframe.startTime : null}
            resetSelection={!timeframe}
            handleDateSelection={this.handleStartDateSelection}
            minDate={startDate}
            maxDate={timeframe && timeframe.endTime ? timeframe.endTime : endDate}
            placeHolderText={'MM/DD/YYYY'}
             />
        </div>
      </div>
    );
  
    let endDatePicker = (
      <div className="project-timeline-date-selector">
        <div className="date-picker-container">
          <DatePicker
            selected={timeframe ? timeframe.endTime : null}
            resetSelection={!timeframe}
            handleDateSelection={this.handleEndDateSelection}
            minDate={timeframe && timeframe.startTime ? timeframe.startTime : startDate}
            maxDate={endDate}
            placeHolderText={'MM/DD/YYYY'}
             />
        </div>
      </div>
    );
  
    let className = 'ProjectTimelineFilters';
    
    return (
      <div className={className}>
        <div className="selector-container">
          <div className="column">
            <div className={'project-timeline-filter-container'}>
              <div className='project-timeline-filter-selector-label'>
                COMPANY
          </div>
              <div className='project-timeline-filter-selector-container'>
                {vendorCompanySelector}
              </div>
              <div className='project-timeline-filter-selector-filtertags'>
                <FilterTags positionRight={true} filters={vendorCompanies} handleFilterRemoved={this.handleVendorCompaniesFilterRemoved} />
              </div>
            </div>
            <div className={'project-timeline-filter-container'}>
              <div className='project-timeline-filter-selector-label'>
                EVENT TYPE
          </div>
              <div className='project-timeline-filter-selector-container'>
                {eventTypeSelector}
              </div>
              <div className='project-timeline-filter-selector-filtertags'>
                <FilterTags positionRight={true} filters={eventTypes} handleFilterRemoved={this.handleEventTypeFilterRemoved} />
              </div>
            </div>
          </div>
          <div className='column'>
            <div className={'project-timeline-filter-container'}>
              <div className='project-timeline-filter-selector-label'>
                USER
            </div>
              <div className='project-timeline-filter-selector-container'>
                {projectMemberSelector}
              </div>
            <div className='project-timeline-filter-selector-filtertags'>
                <FilterTags positionRight={true} filters={projectMembers} handleFilterRemoved={this.handleProjectMemberFilterRemoved} />
              </div>
            </div>
            <div className={'project-timeline-filter-container'}>
              <div className='project-timeline-filter-selector-label'>
                TIME FRAME
              </div>
              <div className='project-timeline-filter-selector-daterange-container'>
                {startDatePicker}
                  {endDatePicker}
              </div>
              <div className='project-timeline-filter-selector-filtertags'>
                <FilterTags positionRight={true} filters={timeframe && [Object.assign({}, timeframe,
                  { name: formatDate(timeframe) })]} handleFilterRemoved={this.handleTimeFrameFilterRemoved} />
              </div>
            </div>
          </div>
          <div className='column'>
            {!locationsSelector ? null :
              <div className={'project-timeline-filter-container'}>
                <div className='project-timeline-filter-selector-label'>
                  LOCATION
            </div>
                <div className='project-timeline-filter-selector-container'>
                  {locationsSelector}
                </div>
                <div className='project-timeline-filter-selector-filtertags'>
                  <FilterTags positionRight={true} filters={locations} handleFilterRemoved={this.handleLocationFilterRemoved} />
                </div>
              </div>
            }
            <div className={'project-timeline-filter-container'}>
              <div className='project-timeline-filter-selector-label'>
                BUILD
              </div>
              <div className='project-timeline-filter-selector-container'>
                  {buildsSelector}
                </div>
                <div className='project-timeline-filter-selector-filtertags'>
                  <FilterTags positionRight={true} filters={builds} handleFilterRemoved={this.handleBuildFilterRemoved} />
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/ProjectTimeline/ProjectTimelineFilters/index.js